import { Currencies } from '@/entities/curency'
import { AllBanksTypes, AllMethodsTypes } from 'syncra-storybook/shared/utils'

export enum WithdrawStatus {
  WaitingProcessing = 1,
  Paid = 10,
  PaidPartially = 20,
  Failed = 30,
  InProgress = 40,
  PayingRightNow = 50,
}

// Статусы для фильтрации трейдера (новый API /v1/trader/withdraws)
export enum TraderWithdrawFilterStatus {
  All = 1, // Все статусы
  Waiting = 2, // В ожидании: WaitingProcessing
  InProgress = 3, // В работе: InProgress, PayingRightNow
  Paid = 4, // Оплаченные: Paid, PaidPartially
  Failed = 5, // Ошибки: Failed
}

export enum AMobileWithdrawMethodTypeTo {
  Unknown = 0,
  TBankByCard = 430,
  SberByPhone = 1201,
  SberByCard = 1202,
  UnknownSbp = -2,
  UnknownCard = -1,
}

export type WithdrawsModel = {
  id: string
  createdAt: string
  userFromId: string
  traderFromId: string
  disputId: string
  bankToName: string
  methodToName: string
  countryToName: string
  recipientFullName: string
  chargeWithdrawCommissionFromPayer: true
  paymentRequisitValue: string
  callbackUrl: string
  currencyFrom: Currencies
  amountFrom: number
  currencyTo: Currencies
  amountTo: number
  factAmountTo: number
  totalCommissionAmount: number
  exchangeRateFromTo: number
  confirmedByTraderAt: string
  withdrawStatus: WithdrawStatus
  errorMessage: string
  requestId: string
  payingAllowedTill: string
  acceptedByTraderAt: string
  factTraderCommissionTo: number
  traderAmountFrom:number
  traderExchangeRateFromTo:number
}

export type NewWithdrawModel = {
  amountTo: number
  currencyTo: Currencies
  requisitTypeTo: AMobileWithdrawMethodTypeTo
  requisitValueTo: string
  requestId: string
  bankToName: AllBanksTypes
  methodToName: AllMethodsTypes
  countryToName: string
  recipientFullName: string
  callbackUrl: string
}

export interface BankConfig {
  name: string
  availableTypes: RequisitType[]
  methodMapping: Record<RequisitType, AMobileWithdrawMethodTypeTo>
}

export enum RequisitType {
  Card = 'card',
  Phone = 'phone',
}

export enum BankType {
  TBank = 'tbank',
  Sber = 'sber',
}
